export class AssetTypeInfo {
  AssetTypeID: number
  AssetGroupCode: string
  AssetGroupName: string
  AssetCategoryCode: string
  AssetCategoryName: string
  AssetTypeCode: string
  AssetTypeName: string
  AssetTypeDesc: string
  AssetTypeCreateDate: string
  AssetTypeCreateBy: string
  AssetTypeCreateByName: string
  AssetTypeUpdateDate: string
  AssetTypeUpdateBy: string
  AssetTypeUpdateByName: string
  AssetTypeFlagDelete: string
  rowFetch: number
  rowOFFSet: number
  itemTotal: number
}
